import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Modal,
  Image,
  Button,
} from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function GalleryPage() {
  const images = [
    {
      id: 1,
      src: "/1.jpg",
      title: "Acción en Pista",
    },
    {
      id: 2,
      src: "/2.jpg",
      title: "Zona de Pits",
    },
    {
      id: 3,
      src: "/3.jpg",
      title: "Staff Organizador",
    },
    {
      id: 4,
      src: "/4.jpg",
      title: "Ambiente del Evento",
    },
    {
      id: 5,
      src: "/5.jpg",
      title: "Puesta a punto",
    },
    {
      id: 6,
      src: "/6.jpg",
      title: "Recta Principal",
    },
    {
      id: 7,
      src: "/7.jpg",
      title: "Salto Espectacular",
    },
    {
      id: 8,
      src: "/8.jpg",
      title: "Curva Técnica",
    },
    {
      id: 9,
      src: "/9.jpg",
      title: "Entrega de Premios",
    },
    {
      id: 10,
      src: "/10.jpg",
      title: "Concentración Total",
    },
    {
      id: 11,
      src: "/11.jpg",
      title: "Final de Carrera",
    },
  ];

  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleShowModal = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  const handlePrev = () => {
    const currentIndex = images.findIndex((img) => img.id === selectedImage.id);
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setSelectedImage(images[prevIndex]);
  };

  const handleNext = () => {
    const currentIndex = images.findIndex((img) => img.id === selectedImage.id);
    const nextIndex = (currentIndex + 1) % images.length;
    setSelectedImage(images[nextIndex]);
  };

  // Hook para detectar las flechas del teclado cuando el modal está abierto
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!showModal) return;
      if (event.key === "ArrowLeft") {
        handlePrev();
      } else if (event.key === "ArrowRight") {
        handleNext();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showModal, selectedImage]);

  return (
    <Container className="mt-4">
      <h2 className="text-center mb-5 border-bottom pb-3">Nuestra Galería</h2>
      <Row>
        {images.map((image) => (
          <Col md={4} className="mb-4" key={image.id}>
            <Card
              className="glass-card h-100 shadow-sm border-0 overflow-hidden rounded-4 hover-shadow"
              style={{ backgroundColor: "#f8f9fa", minHeight: "300px" }}
            >
              <Card.Img
                variant="top"
                src={image.src}
                className="hover-zoom w-100"
                loading="lazy" // Optimización: Carga diferida
                onClick={() => handleShowModal(image)}
                style={{
                  cursor: "pointer",
                  height: "250px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
              <Card.Body className="bg-white">
                <Card.Title>{image.title}</Card.Title>
                <Card.Text>Una breve descripción de la imagen.</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Modal para mostrar la imagen ampliada */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedImage?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="text-center position-relative p-0 bg-dark overflow-hidden rounded-bottom-4"
          style={{
            minHeight: "400px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Pre-carga invisible de la siguiente imagen */}
          {showModal && (
            <img
              src={
                images[
                  (images.findIndex((img) => img.id === selectedImage?.id) +
                    1) %
                    images.length
                ].src
              }
              style={{ display: "none" }}
              alt="preload"
            />
          )}

          <Button
            variant="link"
            className="position-absolute top-50 start-0 translate-middle-y text-white p-3 z-3 border-0"
            onClick={(e) => {
              e.stopPropagation();
              handlePrev();
            }}
            style={{ textShadow: "0 0 10px rgba(0,0,0,0.8)" }}
          >
            <FaChevronLeft size={40} />
          </Button>

          <Image src={selectedImage?.src} fluid alt={selectedImage?.title} />

          <Button
            variant="link"
            className="position-absolute top-50 end-0 translate-middle-y text-white p-3 z-3 border-0"
            onClick={(e) => {
              e.stopPropagation();
              handleNext();
            }}
            style={{ textShadow: "0 0 10px rgba(0,0,0,0.8)" }}
          >
            <FaChevronRight size={40} />
          </Button>
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default GalleryPage;
